import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid, TextField, InputAdornment, FormGroup, FormControlLabel, Switch } from "@mui/material";
import FormSectionHeader from "../../../components/FormSectionHeader";
import {
  changeCurrentWetlandFormValue,
  selectCurrentWetlandForm,
} from "../../../api/services/wetlandforms/wetlandFormsSlice";
import IndicatorList from "../../../features/indicatorList/IndicatorList";

export default function HydrologyTab() {
  const currentForm = useSelector(selectCurrentWetlandForm);
  const dispatch = useDispatch();

  const handleChangeSurfaceWater = (e) => {
    dispatch(changeCurrentWetlandFormValue({ name: e.target.id, value: e.target.value }));
    // TODO: if water table present, check primary indicator? Same with HWT/Saturation
  };

  const handleChangeWaterTable = (e) => {
    dispatch(changeCurrentWetlandFormValue({ name: e.target.id, value: e.target.value }));
  };

  const handleChangeSaturation = (e) => {
    dispatch(changeCurrentWetlandFormValue({ name: e.target.id, value: e.target.value }));
  };

  const handleStandardFormValueChange = (e) => {
    dispatch(changeCurrentWetlandFormValue({ name: e.target.id, value: e.target.value }));
  };

  const handleSwitchInputFormValueChange = (e) => {
    dispatch(changeCurrentWetlandFormValue({ name: e.target.id, value: e.target.checked }));
  };

  return (
    <React.Fragment>
      <Grid container spacing={2} columnSpacing={4}>
        <Grid container item spacing={4}>
          <FormSectionHeader text={"Field Observations"} />
        </Grid>
        <Grid container item spacing={4}>
          <Grid item xs={12} sm={3} md={2}>
            <TextField
              id="surfaceWaterDepth"
              label="Surface Water Depth"
              fullWidth
              value={currentForm?.surfaceWaterDepth ?? ""}
              onChange={handleChangeSurfaceWater}
              InputProps={{
                endAdornment: <InputAdornment position="end">in</InputAdornment>,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3} md={2}>
            <TextField
              id="waterTableDepth"
              label="Water Table Depth"
              fullWidth
              value={currentForm?.waterTableDepth ?? ""}
              onChange={handleChangeWaterTable}
              InputProps={{
                endAdornment: <InputAdornment position="end">in</InputAdornment>,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3} md={2}>
            <TextField
              id="saturationDepth"
              label="Saturation Depth"
              fullWidth
              value={currentForm?.saturationDepth ?? ""}
              onChange={handleChangeSaturation}
              InputProps={{
                endAdornment: <InputAdornment position="end">in</InputAdornment>,
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <IndicatorList indicatorType="Hydrology" indicatorCategory="Primary" />
      <IndicatorList indicatorType="Hydrology" indicatorCategory="Secondary" />
      <FormGroup>
        <FormControlLabel
          control={<Switch id="wetlandHydro" checked={currentForm?.wetlandHydro} onChange={handleSwitchInputFormValueChange} />}
          label="Wetland Hydrology"
          sx={{ mt: 4 }}
        />
      </FormGroup>
      <TextField
        id="recordedData"
        label="Reccorded Data"
        fullWidth
        multiline
        rows={4}
        value={currentForm?.recordedData ?? ""}
        onChange={handleStandardFormValueChange}
        sx={{ mt: 4 }}
      />
      <TextField
        id="hydroComment"
        label="Hydrology Comment"
        fullWidth
        multiline
        rows={4}
        value={currentForm?.hydroComment ?? ""}
        onChange={handleStandardFormValueChange}
        sx={{ mt: 4 }}
      />
    </React.Fragment>
  );
}
